@if ({ value: checkboxChanges$ | async}; as checkboxChanges) {
  <div
    class="switch"
    (click)="toggleSwitch()"
    click-stop-propagation>
    <input
      type="checkbox"
      [checked]="checkboxChanges.value"
      [disabled]="disabled">
      <span class="slider"></span>
    </div>
  }